import { useState, useEffect } from "react";
import { Swiper, SwiperProps, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import { Pill, pills } from "ui/organisms/Tables/StatsFilter/StatsFilter";
import { ReactComponent as Chevron } from "assets/img/chevron-down.svg";
import "swiper/css";
import "./TableFilterButtons.scss";

interface TableFilterButtonsProps {
  updatePillData: React.Dispatch<React.SetStateAction<Pill>>;
  selectedPill: Pill;
}

export const TableFilterButtons = ({ updatePillData, selectedPill }: TableFilterButtonsProps) => {
  const [swiperEnabled, setSwiperEnabled] = useState<boolean>(false);

  const handleResize = () => {
    if (window.innerWidth <= 768) return setSwiperEnabled(true);
    return setSwiperEnabled(false);
  };
  window.addEventListener("resize", handleResize);

  useEffect(() => {
    handleResize();
  }, []);

  const swiperSettingsProps: SwiperProps = {
    modules: [Navigation],
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    spaceBetween: 5,
    slidesPerView: 2,
    breakpoints: {
      768: {
        navigation: false,
        slidesPerView: 4,
      },
      374: {
        slidesPerView: 3,
      },
    },
  };

  const PillButton = ({ pill }: { pill: Pill }) => {
    return (
      <Button
        variant="primary"
        onClick={() => updatePillData(pill)}
        className={`filter-button ${pill.data.tag === selectedPill.data.tag ? "filter-button--active" : ""}`}
      >
        <span>{pill.label}</span>
      </Button>
    );
  };

  return (
    <>
      {swiperEnabled && (
        <div className="pills">
          <div className="swiper-button-prev">
            <Chevron />
          </div>
          <Swiper {...swiperSettingsProps}>
            {pills.map((pill, index) => (
              <SwiperSlide key={index}>
                <PillButton pill={pill} />
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="swiper-button-next">
            <Chevron />
          </div>
        </div>
      )}
      {!swiperEnabled && (
        <div className="pills">
          {pills.map((pill, index) => (
            <PillButton pill={pill} key={index} />
          ))}
        </div>
      )}
    </>
  );
};
